var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  The participant will be unenrolled from the study. Their data to this point will be preserved.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }